import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { BackEndService } from 'src/app/backend-service';
import { Notification } from 'src/app/classes';
import * as moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-details-dialog',
  templateUrl: './notification-details-dialog.component.html',
  styleUrls: ['./notification-details-dialog.component.css']
})
export class NotificationDetailsDialogComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    private _ref: MatDialogRef<NotificationDetailsDialogComponent>,
    private _formBuilder: FormBuilder,
    private _backEndService: BackEndService,
    @Inject(MAT_DIALOG_DATA) private _data: Notification
  ) {
    this.formGroup = this._formBuilder.group({
      "notificationid": _data.notificationid,
      "notificationuser": _data.notificationuser,
      "notificationsubject": _data.notificationsubject,
      "notificationtext": _data.notificationtext,
      "notificationtime": _data.notificationtime,
      "notificationseen": _data.notificationseen
    });

  }

  close() {
    if (!this.notificationIdControl.value) this._data.notificationseen = moment().format("YYYY-MM-DDTHH:mm:ss");
    this._ref.close();
  }

  markMessageAsSeen() {
    if (!this.notificationIdControl.value) {
      this._data.notificationseen = moment().format("YYYY-MM-DDTHH:mm:ss");
      this._ref.close();
      return;
    }
    if (this.notificationSeenControl.value) {
      this._ref.close();
    } else {
      this._backEndService.get("api/notification/seen/" + this.notificationIdControl.value).subscribe(() => {
        this._data.notificationseen = moment().format("YYYY-MM-DDTHH:mm:ss");
        this._ref.close();
      });
    }
  }

  markMessageAsUnseen() {
    if (this.notificationIdControl.value) {
      if (this.notificationSeenControl.value) {
        this._backEndService.get("api/notification/unseen/" + this.notificationIdControl.value).subscribe(() => {
          this.notificationSeenControl.setValue(null);
          this._ref.close(true);
        });
      } else this._ref.close();
    } else {
      this._data.notificationseen = moment().format("YYYY-MM-DDTHH:mm:ss");
      this._ref.close();
      return;
    }
  }

  ngOnInit(): void {
  }

  // CONTROLS
  get notificationIdControl(): AbstractControl {
    return this.formGroup.controls["notificationid"];
  }
  get notificationSeenControl(): AbstractControl {
    return this.formGroup.controls["notificationseen"];
  }

}
